export default "__VITE_ASSET__3XoY2GJo__"